<template>
  <div
    class="menuItem relative flex cursor-pointer items-center justify-center transition-all duration-200"
    @click="setView()"
    @mouseover="isHovering = true"
    @mouseleave="isHovering = false"
  >
    <div
      class="duration-250 rounded-lg p-2 text-gray-300 transition-all hover:text-white"
      :class="{
        'menuItemBg text-white':
          selectedView === viewName && !(showBF && viewName.includes('Gift')),
        menuItemBgBf: showBF && viewName.includes('Gift'),
      }"
    >
      <slot name="svg" />
      <MenuTooltip
        :is-hovering="isHovering"
        :arrow-position="arrowPosition"
        :tooltip-width="tooltipWidth"
        :override-position="overridePosition"
      >
        <slot name="tooltip" />
      </MenuTooltip>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import MenuTooltip from './menuTooltip.vue';

export default {
  components: {
    MenuTooltip,
  },

  props: {
    selectedView: {
      type: String,
      default: '',
    },
    viewName: {
      type: String,
      default: '',
    },
    arrowPosition: {
      type: String,
      default: 'middle',
    },
    tooltipWidth: {
      type: String,
      default: 'w-64',
    },
    overridePosition: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      isHovering: false,
    };
  },

  computed: {
    ...mapGetters(['isBFEarlyAccess', 'isBFRegister', 'isBFHide', 'isBF']),

    ...mapState({
      blackFriday: state => state.state.blackFriday,
      enteredCode: state => state.giftCard.enteredCode,
    }),

    showBF() {
      return this.isBF || this.isEarlyAccess;
    },

    isEarlyAccess() {
      return this.isBFEarlyAccess && this.enteredCode;
    },
  },

  watch: {},

  created() {},

  methods: {
    setView() {
      this.$emit('updateView', this.viewName);
    },
  },
};
</script>

<style>
.menuItemBg {
  background-color: rgba(112, 123, 129, 0.286);
}

.menuItemBgBf {
  background-color: rgb(39, 37, 37);
}

.menuItem {
  width: 5.2rem;
  height: 4rem;
}
</style>
